import { tns } from "../../../../node_modules/tiny-slider/src/tiny-slider";
import { pushDataLayerCard } from "../util/pushDataLayer.js";

export default {

    buildSliderAppsControle: () => {
        var slider = tns({
            container: '#apps-inclusos',
            items: 1,
            center: true,
            loop: true,
            prevButton: false,
            nextButton: false,
            navPosition: 'bottom',
            controls: false,
            autoplay: true,
            speed: 600,
            autoplayTimeout: 3000,
            autoplayButtonOutput: false
        });
    },

    buildSliderPlanoMensal: () => {
        const slider = tns({
            container: '[data-card="mensal"]',
            items: 1,
            slideBy: 'page',
            loop: false,
            controlsPosition: 'bottom',
            navPosition: 'bottom',
            controls: true,
            arrowKeys: true,
            controlsText: ['<', '>']
        });

        slider.events.on('indexChanged', eventCardImpression);
    },

    buildSliderPlanoAnual: () => {
        const slider = tns({
            container: '[data-card="anual"]',
            items: 1,
            slideBy: 'page',
            loop: false,
            controlsPosition: 'bottom',
            navPosition: 'bottom',
            controls: true,
            arrowKeys: true,
            controlsText: ['<', '>']
        });

        slider.events.on('indexChanged', eventCardImpression);
    }

}

function eventCardImpression() {
    const cards = document.querySelectorAll(".cards .item.tns-slide-active");
    const cardsIds = Array.from(cards).map(card => {
        return {
            type: 'impression',
            id: card.querySelector('[data-id]').dataset.id,
            hasDoubleRedes: card.querySelector('.cards--card--details--toggle--btn').classList.contains("active"),
        }
    });

    pushDataLayerCard(cardsIds);
}